<form [formGroup]="incidentForm" class="grid grid-cols-12 gap-4">
  <label for="summary" class="col-span-3 font-semibold">Summary</label>
  <div class="col-span-9"><input pInputText id="summary" type="text" class="w-full mb-1" formControlName="summary"></div>


  <label for="startDate" class="col-span-3 font-semibold">Incident Date</label>
  <p-datepicker fluid class="col-span-9" [showIcon]="true" id="startDate" formControlName="startDate">

  </p-datepicker>

  <label for="priority" class="col-span-3 font-semibold">Priority</label>
  <div class="col-span-9">
    <p-select [options]="priorities()" [formControl]="incidentForm.controls['priorityId'] | formControl"
    optionLabel="name" optionValue="priorityId"></p-select>
  </div>

  <label for="location" class="col-span-3 font-semibold">Location</label>
  <app-location-dropdown class="col-span-9" [locations]="locations()" formControlName="locationId"></app-location-dropdown>

  <label for="description" class="col-span-12 mb- font-semibold">Description</label>
  <div class="col-span-12 mb-1"><textarea pTextarea id="description" rows="5" class="w-full" formControlName="description"  ></textarea></div>


  <div class="col-span-12 flex flex-col gap-1">
    @if (incidentForm.controls['summary'].errors?.['required'] ) {
      <div>
        <p-message severity="error" text="Summary is required"></p-message>
      </div>
    }
    @if (incidentForm.controls['startDate'].errors?.['required']) {
      <div class="">
        <p-message severity="error" text="Incident Date is required"></p-message>
      </div>
    }
    @if (incidentForm.controls['priorityId'].errors?.['required'] || incidentForm.controls['priorityId'].errors?.['min']) {
      <div>
        <p-message severity="error" text="Priority is required"></p-message>
      </div>
    }
  </div>

  <div class="col-span-12 flex w-full justify-end">
    <button pButton class="btn btn-primary" [disabled]="incidentForm.invalid" type="button" (click)="onSubmit()"
      useSubmitBehavior="false">
      {{editMode() ? 'Update Incident' : 'Create Incident'}}
    </button>
  </div>
</form>
